export enum DisplayTheme {
	Light = 'light',
	Dark = 'dark'
}

export const DefaultDisplayTheme = DisplayTheme.Light;
export type Theme = DisplayTheme | 'auto';
